import { ACTION_TYPES } from '../constants';

export default data => ({
  type: ACTION_TYPES.AUTH_VOD_SUCCESS,
  payload: {
    data
  }
});
